import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['12px', '12px'],
  middle: ['24px', '24px'],
  large: ['32px', '32px'],
};

const PlusInSquareIcon = (props) => (
  <svg
    fill="#000000"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={sizes[props.size][0]}
    height={sizes[props.size][1]}
    style={{
      ...(props.shouldPadding
        ? {
            padding: '4px',
          }
        : {}),
    }}
  >
    <path d="M 11.5 6 C 8.4802259 6 6 8.4802259 6 11.5 L 6 36.5 C 6 39.519774 8.4802259 42 11.5 42 L 36.5 42 C 39.519774 42 42 39.519774 42 36.5 L 42 11.5 C 42 8.4802259 39.519774 6 36.5 6 L 11.5 6 z M 11.5 9 L 36.5 9 C 37.898226 9 39 10.101774 39 11.5 L 39 36.5 C 39 37.898226 37.898226 39 36.5 39 L 11.5 39 C 10.101774 39 9 37.898226 9 36.5 L 9 11.5 C 9 10.101774 10.101774 9 11.5 9 z M 23.976562 13.978516 A 1.50015 1.50015 0 0 0 22.5 15.5 L 22.5 22.5 L 15.5 22.5 A 1.50015 1.50015 0 1 0 15.5 25.5 L 22.5 25.5 L 22.5 32.5 A 1.50015 1.50015 0 1 0 25.5 32.5 L 25.5 25.5 L 32.5 25.5 A 1.50015 1.50015 0 1 0 32.5 22.5 L 25.5 22.5 L 25.5 15.5 A 1.50015 1.50015 0 0 0 23.976562 13.978516 z" />
  </svg>
);
PlusInSquareIcon.propTypes = {
  size: PropTypes.string,
  shouldPadding: PropTypes.bool,
};
PlusInSquareIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
};

export default PlusInSquareIcon;
